'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dDocument from "./presto.-Credentials-View$-By-Document.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dSeed from "./presto.-Credentials-View$-By-Seed.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dSite$002dAnd$002dGroup from "./presto.-Credentials-View$-By-Site-And-Group.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dTfa from "./presto.-Credentials-View$-By-Tfa.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$65() {
}
export { $c_Lpresto_CredentialsView$$anon$65 as $c_Lpresto_CredentialsView$$anon$65 };
$p = $c_Lpresto_CredentialsView$$anon$65.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$65;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$65() {
}
export { $h_Lpresto_CredentialsView$$anon$65 as $h_Lpresto_CredentialsView$$anon$65 };
$h_Lpresto_CredentialsView$$anon$65.prototype = $p;
$p.aeq = (function(x$0) {
  if (false) {
    return 0;
  }
  if ((x$0 instanceof $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dTfa.$c_Lpresto_CredentialsView$ByTfa)) {
    return 1;
  }
  if ((x$0 instanceof $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dSite$002dAnd$002dGroup.$c_Lpresto_CredentialsView$BySiteAndGroup)) {
    return 2;
  }
  if ((x$0 instanceof $j_presto$002e$002dCredentials$002dView$0024$002dBy$002dDocument.$c_Lpresto_CredentialsView$ByDocument)) {
    return 3;
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x$0);
});
var $d_Lpresto_CredentialsView$$anon$65 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$65, "presto.CredentialsView$$anon$65", ({
  Gu: 1,
  a: 1,
  e: 1,
  H: 1
}));
export { $d_Lpresto_CredentialsView$$anon$65 as $d_Lpresto_CredentialsView$$anon$65 };
//# sourceMappingURL=presto.-Credentials-View$$anon$65.js.map
